<div class="preloader__container" [class.preloader__container--loading]="loading">
    <ng-content></ng-content>
    <div
        class="preloader__overlay preloader__overlay--set"
        [class.preloader__overlay--atlas]="type === 'atlas'"
        *ngIf="loading"
    >
        <div class="preloader__loading-content">
            <ng-container *ngIf="type === 'default'">
                <div *ngIf="loadingMessage" class="preloader__loading-message">
                    {{ loadingMessage }}
                </div>
                <img
                    src="assets/icons/spinner-icon.svg"
                    alt="Loading..."
                    class="preloader__loading-icon animation-spin"
                />
            </ng-container>
            <ng-container *ngIf="type === 'atlas'">
                <div class="preloader__loading-atlas"></div>
                <div *ngIf="loadingMessage" class="preloader__loading-message__atlas">
                    {{ loadingMessage }}
                </div>
            </ng-container>
        </div>
    </div>
</div>
